import React, { useEffect, useMemo, useState } from "react";

import TagPicker from "src/components/TagPicker";
import tagService from "src/services/tagService";
import useTags from "src/features/Tags/hooks/useTags";

function readSetup() {
  try {
    const p = JSON.parse(localStorage.getItem("whatsapp_setup") || "{}");
    return {
      workspaceId: p.workspaceId || p.workspace_id || null,
      accountId:
        p.whatsappAccountId || p.whatsapp_account_id || p.accountId || p.account_id || null,
      phoneNumberId: p.phoneNumberId || p.phone_number_id || null,
    };
  } catch {
    return { workspaceId: null, accountId: null, phoneNumberId: null };
  }
}

/**
 * Tag editor for one contact — reads the workspace catalog, saves the set via
 * the contact-tags endpoint, and can create a tag inline.
 */
export default function ContactTagsSection({ contact, onChanged }) {
  const setup = useMemo(readSetup, []);
  const { tags, createTag } = useTags();

  const [ids, setIds] = useState(() => (contact?.tags || []).map((t) => t.id));
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setIds((contact?.tags || []).map((t) => t.id));
  }, [contact?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const ready =
    setup.workspaceId && setup.accountId && setup.phoneNumberId && contact?.id;

  const save = async (next) => {
    if (!ready) return;
    const previous = ids;
    setIds(next);
    setBusy(true);
    try {
      await tagService.setContactTags(
        setup.workspaceId,
        setup.accountId,
        setup.phoneNumberId,
        contact.id,
        next,
      );
      onChanged?.();
    } catch (err) {
      setIds(previous);
      console.error("Failed to update contact tags.", err);
    } finally {
      setBusy(false);
    }
  };

  if (!ready) return null;

  return (
    <TagPicker
      catalog={tags}
      value={ids}
      onChange={save}
      onCreateTag={createTag}
      disabled={busy}
    />
  );
}
